module.exports = __webpack_public_path__ + "static/img/cacib.01f4a030.svg";